if (!customElements.get('header-cart-count')) {
  customElements.define(
    'header-cart-count',
    class HeaderCartCount extends HTMLElement {
      connectedCallback() {
        this.badge = this.querySelector('[data-cart-count-badge]');
        this.status = this.querySelector('[data-cart-count-status]');
        this.requestId = 0;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      onCartUpdate(event) {
        const count = event && event.cartData && event.cartData.item_count;
        if (typeof count === 'number') {
          this.requestId += 1;
          this.render(count);
          return;
        }

        // product-form が渡すのは /cart/add.js の戻り（追加した行）で item_count を持たない
        this.refresh();
      }

      refresh() {
        this.requestId += 1;
        const requestId = this.requestId;

        fetch(`${routes.cart_url}.js`)
          .then((response) => {
            // 失敗時も JSON が返るため、ok を見ないと item_count が undefined のまま描画される
            if (!response.ok) throw new Error(`cart.js responded ${response.status}`);
            return response.json();
          })
          .then((cart) => {
            // 連打で並走した fetch が逆順で解決したとき、古い個数で上書きしない
            if (requestId !== this.requestId) return;
            this.render(cart.item_count);
          })
          .catch((error) => console.error(error));
      }

      render(count) {
        if (typeof count !== 'number') return;

        if (this.badge) {
          this.badge.textContent = count;
          this.badge.hidden = count === 0;
        }

        if (this.status) {
          if (count === 0) this.status.textContent = '';
          else this.status.textContent = (this.dataset.countTemplate || '').replace('%count%', count);
        }
      }
    },
  );
}
